(function() {
    'use strict';
    var ShareCandidateCtrl = function($scope, $compile,ajaxCall, xmsNotificationFactory) {
        console.log("Inside ShareCandidateCtrl");
        $scope.ngModel = {};
        console.log("$scope.shareCandidateModel"+$scope.ngModel);
        $scope.ngModel.shareTo="user";
        $scope.shareWithLabel="User";

        $scope.$watch(
            function(){
                return $scope.ngModel.shareTo;
            },
            function(newVal, oldVal){
                if(newVal!=oldVal){
                    $scope.ngModel.selectShareTo=""
                    if(newVal == "user"){
                        $scope.shareWithLabel = "User"
                    }
                    else{
                        $scope.shareWithLabel = "OU"
                    }
                }
            }
        );

        $scope.fnShareCandidate = function($event) {
            $event.preventDefault();
            var ajaxUrl = WEBAPP_PATH + "/candidate/shareCandidate?";
            var data    = $scope.ngModel;

            console.log("data .."+data)

            ajaxCall.getData(ajaxUrl, data).then(
                function(result) {
                    console.log(result.data.responseType);
                    xmsNotificationFactory.addObj({id: "shareCandidate", type: result.data.responseType, bodyHtml: result.data.responseMessage, timeout:5});
                    $scope.ok();
                },
                function(result) {
                    console.log("failure ");
                    var alertMessage = "Error occurred. Please try again later.";
                    xmsNotificationFactory.addObj({id: "shareCandidate", type: "danger", bodyHtml: alertMessage, timeout:10});
                    $scope.ok();

                }
            );
            $event.preventDefault();
        }

    }
    ShareCandidateCtrl.$inject = ['$scope', '$compile', 'ajaxCall', 'xmsNotificationFactory'];
    angular.module('app').controller('ShareCandidateCtrl', ShareCandidateCtrl);
}());
